import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PositionForm from '../PositionForm';
import Dialog from '@afosto/app-components-react/Dialog';
import RegisterFormProvider from '@afosto/app-components-react/RegisterFormProvider';
import translations from './translations';

const PositionDialog = ({
  isOpen,
  locationId,
  onClose,
  onSubmit,
  position,
  suggestions,
  title,
  description,
  disableRestoreFocus,
}) => {
  const formRef = useRef(null);

  const handleCancel = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleSubmit = () => {
    const form = formRef?.current;

    if (form) {
      form.onSubmit();
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} disableRestoreFocus={disableRestoreFocus} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {description}
        <RegisterFormProvider value={{ formRef }}>
          <PositionForm
            locationId={locationId}
            position={position}
            onSubmit={onSubmit}
            suggestions={suggestions}
            renderActions={false}
          />
        </RegisterFormProvider>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="space-between" width="100%">
          <Button variant="outlined" onClick={handleCancel}>
            <FormattedMessage {...translations.actions.cancel} />
          </Button>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            <FormattedMessage {...translations.actions.save} />
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

PositionDialog.propTypes = {
  description: PropTypes.string,
  disableRestoreFocus: PropTypes.bool,
  isOpen: PropTypes.bool,
  locationId: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  position: PropTypes.string,
  suggestions: PropTypes.array,
  title: PropTypes.string,
};

PositionDialog.defaultProps = {
  description: '',
  disableRestoreFocus: false,
  isOpen: false,
  locationId: undefined,
  onClose: undefined,
  onSubmit: undefined,
  position: '',
  suggestions: [],
  title: '',
};

export default PositionDialog;
